import React from 'react';
import AsyncSelect from 'react-select/async';
import { isSome, renderIf } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

function BaasicAsyncSelectTemplate({ t, field, validation, reference, label, ...props }) {
	let labelHtml, errorHtml, requiredMark;
	if (field) {
		requiredMark =
			field.rules && field.rules.indexOf('required') !== -1 ? <span className="type--color--warning">*</span> : null;
		labelHtml = (
			<label htmlFor={field.id}>
				{t(field.label)} {requiredMark}
				{renderIf(
					field.$rules && field.$rules.includes('required') && !isSome(field.error) && field.$value && validation
				)(
					<span className="form__label--check type--color--success">
						<i className="fa fa-check-circle"></i>
					</span>
				)}
			</label>
		);
		errorHtml = renderIf(isSome(field) && isSome(field.error))(
			<p className="type--tny type--color--error">{t(field.error)}</p>
		);
	} else {
		labelHtml = <label>{t(label)}</label>;
	}
	return (
		<React.Fragment>
			{labelHtml}
			<AsyncSelect className="react-select-override" classNamePrefix="react-select" {...props} ref={ref => (reference != null ? reference(ref) : null)} />
			{errorHtml}
		</React.Fragment>
	);
}

export default defaultTemplate(BaasicAsyncSelectTemplate);
